/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Form, Row, Col, Card, Descriptions, message, Menu, Dropdown, Collapse, Icon, Result, Modal, Button } from "antd";
import keyMirror from "key-mirror";
import { List, Map, OrderedMap } from "immutable";
import moment from "moment";
import cx from "classnames";
import _capitalize from "lodash/capitalize";
import FileViewer from "./../modules/document-viewer/src/components/index";
import SignzyIcon from "assets/signzy-logo-black.png";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { INPUT_TYPES } from "constants";
import { DOCUMENT_CURRENT_STATUS, GENDER_TYPES, DOCUMENT_REJECTION_REASONS, BANK_ACCOUNT_TYPES } from "constants/enums";
import { AssociateRecord } from "records";
import CompanyService from "services/company-service";
import Modals from "components/modals";
import "styles/form.css";
import "styles/document-review.css";
import { AddressRecord, BankAccountRecord } from "records/index";

const { confirm } = Modal;

const DescItem = Descriptions.Item;
const { Panel } = Collapse;

const PARSER_FORM_FIELDS = new OrderedMap({
    first_name: {
        label: "First & Middle Name",
        key: "first_name",
        placeholder: "Name",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    last_name: {
        label: "Last Name",
        key: "last_name",
        placeholder: "Name",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT
    },
    name_pan: {
        label: "Name as on PAN",
        key: "name_pan",
        placeholder: "Name as on PAN",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    name_aadhar: {
        label: "Name as on Adhaar",
        key: "name_adhaar",
        placeholder: "Name as on Adhaar",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    dob_pan: {
        label: "Date of Birth as on PAN",
        placeholder: "Date of Birth as on PAN",
        key: "dob_pan",
        className: "form-field fb-15",
        type: INPUT_TYPES.DATE,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    dob_aadhar: {
        label: "Date of Birth as on Adhaar (YYYY-MM-DD)",
        placeholder: "Date of Birth as on Adhaar (YYYY-MM-DD)",
        key: "dob_adhaar",
        className: "form-field fb-15",
        type: INPUT_TYPES.DATE,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    father_name: {
        label: "Father's Name",
        key: "father_name",
        placeholder: "Father's Name",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    pan: {
        label: "Pan No.",
        placeholder: "PAN",
        key: "pan",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    dob: {
        label: "Date of Birth",
        placeholder: "Date of Birth",
        key: "dob",
        className: "form-field fb-15",
        type: INPUT_TYPES.DATE,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    gender: {
        label: "Gender",
        key: "gender",
        placeholder: "Gender",
        className: "form-field fb-15",
        type: INPUT_TYPES.SELECT,
        options: GENDER_TYPES.map((value, key) => ({
            key: key,
            value: String(value),
            label: key
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    phone: {
        className: "form-field",
        key: "phone",
        type: INPUT_TYPES.TEXT,
        label: "Phone Number",
        rules: [
            {
                required: true,
                message: "Phone Number is required"
            },
            {
                pattern: "[0-9]{10}",
                message: "Enter valid Phone no"
            }
        ]
    },
    aadhar: {
        label: "Aadhar Number",
        key: "aadhar",
        className: "form-field fb-15",
        placeholder: "Aadhaar Number",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field Required"
            },
            {
                pattern: "^[0-9*]{12}$",
                message: "Enter valid Aadhar no"
            }
        ]
    },
    "address.address_line_1": {
        label: "Address",
        key: "address_line_1",
        placeholder: "Address",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    "address.pincode": {
        label: "Pincode",
        key: "pincode",
        placeholder: "Pincode",
        className: "form-field fb-15",
        type: INPUT_TYPES.TEXT,
        rules: [ 
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                //eslint-disable-next-line
                pattern: "^[1-9][0-9]{5}$",
                message: "Enter valid Pincode"
            }
        ]
    },
    "address.city": {
        label: "City",
        placeholder: "City",
        key: "city",
        className: "form-field fb-15",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "name",
        showSearch: true,
        onSearch: (str) => {
            return str && str.length > 0
                ? CompanyService.locationLookup({
                    ["city_name"]: str
                }).then(({ data }) => {
                    if (!data || !data.length) {
                        return {
                            data: [{
                                id: null,
                                name: _capitalize(str)
                            }]
                        };
                    }
                    return {
                        data: new List(data).toMap().mapKeys((k, _) => _.name).toList().toArray()
                    };
                })
                : Promise.resolve({
                    data: []
                });
        },
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    "address.district": {
        label: "District",
        placeholder: "District",
        key: "district",
        className: "form-field fb-15",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "name",
        showSearch: true,
        onSearch: (str) => {
            return str && str.length > 0
                ? CompanyService.locationLookup({
                    ["district_name"]: str
                }).then(({ data }) => {
                    if (!data || !data.length) {
                        return {
                            data: [{
                                id: null,
                                name: _capitalize(str)
                            }]
                        };
                    }
                    return {
                        data: new List(data).toMap().mapKeys((k, _) => _.name).toList().toArray()
                    };
                })
                : Promise.resolve({
                    data: []
                });
        }
    },
    // "address.district": {
    //     label: "District",
    //     placeholder: "District",
    //     type: INPUT_TYPES.OBJECT_SELECT,
    //     className: "form-field fb-15",
    //     labelProp: "name",
    //     showSearch: true
    // },
    "address.state": {
        label: "State",
        placeholder: "State",
        key: "state",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "name",
        className: "form-field fb-15",
        showSearch: true,
        onSearch: (str) => {
            return str && str.length > 0
                ? CompanyService.locationLookup({
                    ["state_name"]: str
                }).then(({ data }) => ({
                    data: new List(data).toMap().mapKeys((k, _) => _.name).toList().toArray()
                })
                )
                : Promise.resolve({
                    data: []
                });
        },
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },
    "bank.account_type": {
        type: INPUT_TYPES.SELECT,
        options: BANK_ACCOUNT_TYPES.map((value, label) => ({
            value,
            label
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        label: "Account Type",
        className: "form-field fb-33"
    },
    "bank.account_holder_name": {
        type: INPUT_TYPES.TEXT,
        options: [],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        label: "Account Holder Name",
        className: "form-field fb-33"
    },
    "bank.account_number": {
        type: INPUT_TYPES.TEXT,
        label: "Account Number",
        className: "form-field fb-33",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    "bank.ifsc_code": {
        type: INPUT_TYPES.OBJECT_SELECT,
        label: "IFSC Code",
        labelProp: "ifsc_code",
        className: "form-field fb-33",
        showSearch: true,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    "bank.bank_branch": {
        type: INPUT_TYPES.OBJECT_TEXT,
        label: "Bank Branch Name",
        className: "form-field fb-33",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    is_vernacular_required: {
        label: "Vernacular Required",
        key: "is_vernacular_required",
        placeholder: "Vernacular Required",
        className: "form-field fb-15",
        type: INPUT_TYPES.SELECT,
        options: [
            {
                label: "True",
                value: 'true'
            },
            {
                label: "False",
                value: 'false'
            }
        ],
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ]
    },

});

const SIGNZY_PARSER_TYPES = keyMirror({
    PAN: null,
    AADHAR_MASK_FRONT : null,
    AADHAR_MASK_BACK : null,
    // AADHAAR: null,
    GSTIN: null,
    CHEQUE: null,
    CHEQUE_1 : null,
    CHEQUE_2 : null,
    CHEQUE_3 : null,
});

const DOCUMENT_TYPE_FIELD_CONFIGS = Map({
    [SIGNZY_PARSER_TYPES.PAN]: ["first_name", "last_name", "name_pan", "dob_pan", "father_name", "pan", "gender", "phone" , "is_vernacular_required"],
    // [SIGNZY_PARSER_TYPES.AADHAAR]: [
    //     "first_name",
    //     "last_name",
    //     "name_aadhar",
    //     "dob_aadhar",
    //     "aadhar",
    //     "gender",
    //     "phone",
    //     "address.address_line_1",
    //     "address.city",
    //     "address.district",
    //     "address.pincode",
    //     "address.state"
    // ],
    [SIGNZY_PARSER_TYPES.AADHAR_MASK_FRONT]: [
        "first_name",
        "last_name",
        "name_aadhar",
        "dob_aadhar",
        "aadhar",
        "gender",
        "phone",
        "address.address_line_1",
        "address.city",
        "address.district",
        "address.pincode",
        "address.state"
    ],
    [SIGNZY_PARSER_TYPES.AADHAR_MASK_BACK]: [
        "first_name",
        "last_name",
        "name_aadhar",
        "dob_aadhar",
        "aadhar",
        "gender",
        "phone",
        "address.address_line_1",
        "address.city",
        "address.district",
        "address.pincode",
        "address.state"
    ],
    [SIGNZY_PARSER_TYPES.CHEQUE]: [
        "bank.account_type",
        "bank.account_holder_name",
        "bank.account_number",
        "bank.ifsc_code",
        "bank.bank_branch"
    ],
    [SIGNZY_PARSER_TYPES.CHEQUE_1]: [
        "bank.account_type",
        "bank.account_holder_name",
        "bank.account_number",
        "bank.ifsc_code",
        "bank.bank_branch"
    ],
    [SIGNZY_PARSER_TYPES.CHEQUE_2]: [
        "bank.account_type",
        "bank.account_holder_name",
        "bank.account_number",
        "bank.ifsc_code",
        "bank.bank_branch"
    ],
    [SIGNZY_PARSER_TYPES.CHEQUE_3]: [
        "bank.account_type",
        "bank.account_holder_name",
        "bank.account_number",
        "bank.ifsc_code",
        "bank.bank_branch"
    ],
});

const PARSER_APPLICABLE_CONFIG = Map({
    [SIGNZY_PARSER_TYPES.PAN]: true,
    [SIGNZY_PARSER_TYPES.AADHAR_MASK_FRONT]: true,
    [SIGNZY_PARSER_TYPES.AADHAR_MASK_BACK]: true,
    // [SIGNZY_PARSER_TYPES.AADHAAR]: true,
    [SIGNZY_PARSER_TYPES.GSTIN]: true,
    [SIGNZY_PARSER_TYPES.CHEQUE]: true,
    [SIGNZY_PARSER_TYPES.CHEQUE_1]: true,
    [SIGNZY_PARSER_TYPES.CHEQUE_2]: true,
    [SIGNZY_PARSER_TYPES.CHEQUE_3]: true

});

const DOCUMENT_CODES = Map({
    7: SIGNZY_PARSER_TYPES.PAN,
    '63-12': SIGNZY_PARSER_TYPES.AADHAR_MASK_FRONT,
    '63-13' : SIGNZY_PARSER_TYPES.AADHAR_MASK_BACK,
    // 63: SIGNZY_PARSER_TYPES.AADHAAR,
    12: SIGNZY_PARSER_TYPES.PAN,
    13: SIGNZY_PARSER_TYPES.AADHAAR,
    2: SIGNZY_PARSER_TYPES.GSTIN,
    34: SIGNZY_PARSER_TYPES.CHEQUE,
    81 : SIGNZY_PARSER_TYPES.CHEQUE_1,
    82: SIGNZY_PARSER_TYPES.CHEQUE_2,
    83: SIGNZY_PARSER_TYPES.CHEQUE_3,

});

const newDocSignzy = Map({
    '63-12': SIGNZY_PARSER_TYPES.AADHAR_MASK_FRONT,
    '63-13' : SIGNZY_PARSER_TYPES.AADHAR_MASK_BACK,
    81 : SIGNZY_PARSER_TYPES.CHEQUE,
    82: SIGNZY_PARSER_TYPES.CHEQUE,
    83: SIGNZY_PARSER_TYPES.CHEQUE,
})
class SignzyDataForm extends React.PureComponent {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    state = {
        disableActionBtn: true,
        showRejectionModal: false,
        showDeletionModal: false
    };

    get parserFormFields() {
        const documentType = this.props.form.getFieldValue("document_type");
        const parserType = DOCUMENT_CODES.get(documentType);
        if (parserType !== SIGNZY_PARSER_TYPES.GSTIN) {
            return PARSER_FORM_FIELDS.filter((v, k) => DOCUMENT_TYPE_FIELD_CONFIGS.get(parserType, []).includes(k));
        } else {
            var formDataObj = {};
            this.props.associates.forEach((_, key) => {
                let formData = {
                    label: _.name,
                    key: `associate_${_.id}`,
                    placeholder: _.name,
                    className: "form-field fb-15",
                    type: INPUT_TYPES.TEXT
                };

                formDataObj[`associate_${_.id}`] = formData;
            });

            return new OrderedMap(formDataObj);
        }
    }

    getDescription = (data = []) => {
        return (
            <div className={"ml-10"}>
                <Descriptions column={1}>
                    {data.map((_, k) => (
                        // eslint-disable-next-line react/jsx-key
                        <DescItem key={k} label={_[0]}>
                            {_[1]}
                        </DescItem>
                    ))}
                </Descriptions>
            </div>
        );
    };

    parseData = () => {
        const parserType =  newDocSignzy.get(this.props.form.getFieldValue("document_type")) ?newDocSignzy.get(this.props.form.getFieldValue("document_type")) : DOCUMENT_CODES.get(this.props.form.getFieldValue("document_type"));
        if (parserType) {
            const { associate, document_type } = this.props.form.getFieldsValue(["associate", "document_type"]);
            let docType = document_type.toString().includes('-') ? document_type.toString().split('-')[0] : document_type;
            this.props.parseData(
                this.props.file
                    .set("document", this.props.docMasterList.find((_) => _.id === Number(docType)))
                    .setIn(["parse_data"], {
                        associate: associate
                    }),
               parserType.toLowerCase().includes("aadhar") ? 'aadhaar' : parserType
            );
        } else {
            message.warn("You have no selected a valid document");
        }
    };

    onSubmit = (event, action, reason, remarks) => {
        event && event.preventDefault();
        if (action === "REJECT") {
            this.props.updateDocument(
                action,
                this.props.file.merge({
                    remarks: remarks ? remarks : reason,
                    document_status: DOCUMENT_CURRENT_STATUS.get("Rejected")
                })
            );
        } else if (action === "DELETE") {
            this.props.updateDocument(
                action,
                this.props.file.merge({
                    remarks: remarks ? remarks : reason,
                    document_status: DOCUMENT_CURRENT_STATUS.get("Rejected"),
                    is_active: false
                })
            );
        } else if (action === "APPROVE") {
            this.props.form.validateFields((err, formValues) => {
                if(formValues?.dob_aadhar?.toDate() == "Invalid Date"){
                    message.error("Please fill Date of Birth as on Adhaar")
                    return
                }
                if (!err) {
                    try {

                        const values = Object.assign({}, formValues);
                        const { document_type, address, bank, ...restValues } = values;

                        let associate = null;
                        let associateAddress = null;
                        let bankDetails = null;
                        if (restValues.associate) {
                            associate = this.props.associates.find((_) => Number(_.id) === Number(restValues.associate));
                            if (!associate) {
                                associate = new AssociateRecord();
                            }

                            associate = associate.merge(restValues);
                            if (address && address.address_line_1) {
                                associateAddress = this.props.addressesList.find(
                                    (_) => Number(_.associate) === Number(restValues.associate)
                                );
                                if (!associateAddress) {
                                    associateAddress = new AddressRecord();
                                }
                                associateAddress = associateAddress.merge({
                                    ...address,
                                    address_type: 5,
                                    is_communication_address: true,
                                    residing_since: moment("2000-01-01")
                                });
                            }
                        }
                        if(document_type == "63-13" || document_type == "63-12"){
                            const hasLast4Digits = /^[0-9*]*\d{4}$/.test(associate.get('aadhar'));

                            if (!hasLast4Digits) {
                                message.error("Invalid Aadhar Number")
                                return
                            } 
                        }
                        if (bank && bank.account_type) {
                            bankDetails = this.props.bankAccounts && this.props.bankAccounts.find(_ => _.account_type === bank.account_type);
                            if (bankDetails) {
                                bankDetails = bankDetails.merge({
                                    ...bank
                                });
                            } else {
                                bankDetails = new BankAccountRecord(bank);
                            }
                        }

                        if (!associate) {
                            associate = [];
                            for (let key in restValues) {
                                if (key.indexOf('associate_') >= 0) {
                                    let associateId = key.split('_')[1];
                                    let associateData = this.props.associates.find((_) => Number(_.id) === Number(associateId));
                                    associateData = associateData.merge({ name_gst: restValues[key] });
                                    associate.push(associateData);
                                }
                            }
                        }
                        this.props.updateDocument(
                            action,
                            this.props.file.merge({
                                document: this.props.docMasterList.find((_) => _.id === Number(document_type.includes('-') ? document_type.split('-')[0] : document_type)),
                                document_option : document_type.includes('-') ? Number(document_type.split('-')[1]) : null,
                                document_status: DOCUMENT_CURRENT_STATUS.get("Verified"),
                                parse_data: { ...this.props.file.parse_data, associate: restValues.associate }
                            }),
                            associate,
                            associateAddress,
                            bankDetails && bankDetails.formValues
                        );
                    } catch (error) {
                        console.error("--> err -> ", error);
                    }
                }
            });
        }
    };

    titleFormFields = new OrderedMap({
        document_type: {
            type: INPUT_TYPES.SELECT,
            placeholder: "Document Type",
            filterOption: (value, option) => {
                if (value) {
                    return (
                        option.props.label && option.props.label.toLocaleLowerCase().includes(value.toLocaleLowerCase())
                    );
                }
                return true;
            },
            optionFilterProp: "label",
            optionLabelProp: "label",
            dropdownMatchSelectWidth: false,
            onSelect: this.onSelectDocument,
            showSearch: true,
            size: "small",
            style: {},
            // options: ,
            rules: [
                {
                    required: true,
                    message: "Document Type is required"
                }
            ],
            className: "mr-5 mb-0"
        },
        associate: {
            type: INPUT_TYPES.SELECT,
            placeholder: "Applicant",
            filterOption: true,
            optionFilterProp: "label",
            optionLabelProp: "label",
            dropdownMatchSelectWidth: false,
            onSelect: this.onSelectApplicant,
            size: "small",
            style: {},
            options: new List([]),
            className: "mr-5 mb-0"
        }
    });

    getViewerTitle = () => {
        const documentType = this.props.form.getFieldValue("document_type");
        const isApplicantApplicable = [6, 7, 12, 13, 51, 52, 61, 63, 9, 94, 100].includes(Number(documentType));
        const isAadharApplicable = ['63-12' ,'63-13'].includes(documentType);
        let baseFields = this.titleFormFields;
        if (!this.props.file) {
            baseFields = baseFields
                .setIn(["document_type", "disabled"], true)
                .setIn(["associate", "disabled"], true);
        }
        if (isApplicantApplicable || isAadharApplicable) {
            baseFields = baseFields
                .setIn(
                    ["associate", "rules"],
                    [
                        {
                            required: true
                        }
                    ]
                )
                .setIn(["associate", "disabled"], false);
        } else {
            baseFields = baseFields
                .setIn(
                    ["associate", "rules"],
                    [
                        {
                            required: false
                        }
                    ]
                )
                .setIn(["associate", "disabled"], true);
        }
        return (
            <div className={"d-flex"} >
                {baseFields
                    .map((field, fieldName) => {
                        if (fieldName === "associate") {
                            field.options = this.props.associates
                                .toList()
                                .map((_) => ({
                                    key: _.id,
                                    value: String(_.id),
                                    label: _.name,
                                    rest: { label: _.name }
                                }))
                                .push({
                                    key: "new-applicant",
                                    value: "new_applicant",
                                    label: "New Applicant/Guarrantor"
                                });
                        }
                        if (fieldName === "document_type") {
                            field.options = List(this.props.docMasterList)
                                .filter((_) => (_.id !== 47 && _.id !== 14))
                                .groupBy((_) => _ && _.document_category && _.document_category.name)
                                .filter((_) => _.size > 0)
                                .map((options) =>
                                    options
                                        .map((__) => {if(__.document_document_type_option.length > 0){
                                            let docOptions = __.document_document_type_option.map((docOption) => ({
                                                key: `${__.id}-${docOption.id}`,
                                                value : `${__.id}-${docOption.id}`,
                                                label: docOption.document_type_name,
                                                rest: { label: docOption.document_type_name }
                                            })) 
                                        return  docOptions;                                            
                                        }else{
                                           return { key: __.id,
                                            value: String(__.id),
                                            label: __.document_name,
                                            rest: { label: __.document_name }}
                                        }
                                        })
                                        .toArray().flat()
                                );
                        }
                        return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                    })
                    .toList()
                    .toArray()}
            </div>
        );
    };

    get _isParserApplicable() {
        const documentType = this.props.form.getFieldValue("document_type");
        const parserType = DOCUMENT_CODES.get(documentType);
        return PARSER_APPLICABLE_CONFIG.get(parserType, false);
    }

    customPanelStyle = {
        background: "#f7f7f7",
        borderRadius: 4,
        marginBottom: 24,
        border: 0,
        overflow: "hidden"
    };

    getValueFromObject = bankBranch => {
        if (!bankBranch) {
            return null;
        }
        return bankBranch.name;
    };

    setBankBranchName = branch => {
        this.props.form.setFieldsValue({
            "bank.bank_branch": branch
        });
    };

    ifscLookup = str =>
        CompanyService.ifscLookup(str).then(({ data }) => ({
            data: data.results
        }));

    get _parserForm() {
        const parserType = DOCUMENT_CODES.get(this.props.form.getFieldValue("document_type"));

        const signzyData = this.props.file && this.props.file.parse_data;
        let formattedData = null;
        if (signzyData && signzyData !== [] && Object.keys(signzyData).length && !['CHEQUE' , 'CHEQUE_1' , 'CHEQUE_2' , 'CHEQUE_3'].includes(parserType)) {
            formattedData = signzyData && [
                ["Name", signzyData.first_name],
                ["Date of Birth", signzyData.dob],
                ["Gender", signzyData.gender],
                ["Father's Name", signzyData.father_name]
            ];
            if(signzyData.adhaar_no){
                formattedData.push(["Aadhar Number", signzyData.adhaar_no]);
            }
            if (signzyData.pan) {
                formattedData.push(["PAN", signzyData.pan]);
            }
            if (signzyData.address) {
                formattedData.push(
                    ["Address", signzyData.address.address_line_1],
                    ["Pincode", signzyData.address.pincode],
                    ["City", signzyData.address.city],
                    ["District", signzyData.address.district],
                    ["State", signzyData.address.state],
                );
            }
        }
        if (signzyData && signzyData !== [] && Object.keys(signzyData).length && ['CHEQUE' , 'CHEQUE_1' , 'CHEQUE_2' , 'CHEQUE_3'].includes(parserType) && signzyData.bank) {
            formattedData = signzyData && [
                ["Account Holder Name", signzyData.bank.name],
                ["Account Number", signzyData.bank.account_number],
                ["Bank Branch", signzyData.bank.bank_branch],
                ["IFSC Code", signzyData.bank.ifsc_code]
            ];
        }

        return (
            <React.Fragment>
                {formattedData ? (
                    <div style={{ flexBasis: "100%", marginBottom: "10px" }}>
                        <Collapse
                            bordered={false}
                            defaultActiveKey={["1"]}
                            expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}>
                            <Panel style={this.customPanelStyle} header={"Signzy Data"} key={"1"}>
                                {this.getDescription(formattedData)}
                            </Panel>
                        </Collapse>
                    </div>
                ) : null}
                <div className={cx("form")}>
                    {(this.parserFormFields || Map({}))
                        .map((field, fieldName) => {
                            if (fieldName === "address.district") {
                                let city = this.props.form.getFieldValue("address.city");
                                if (city && !city.id) {
                                    field.disabled = false;
                                    field.rules = [
                                        {
                                            required: true,
                                            message: "Field is mandatory"
                                        }
                                    ];
                                } else {
                                    field.disabled = true;
                                    field.rules = [];
                                }
                            }
                            if (fieldName === "bank.ifsc_code") {
                                field.onSearch = this.ifscLookup;
                                field.onSelect = this.setBankBranchName;
                            }
                            if (fieldName === "bank.bank_branch") {
                                field.getValueFromObject = this.getValueFromObject;
                            }
                            return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                        })
                        .toList()}
                </div>
            </React.Fragment>
        );
    }

    closeModal = () => {
        this.setState({
            showRejectionModal: false,
            rejectionReason: null
        });
    };

    closeDeleteModal = () => {
        this.setState({
            showDeletionModal: false,
            rejectionReason: null
        });
    };

    submitModal = (reason, remarks) => {
        this.setState(
            {
                showRejectionModal: false
            },
            () => {
                this.onSubmit(null, "REJECT", reason, remarks);
            }
        );
    };

    submitDeleteModal = (reason, remarks) => {
        this.setState(
            {
                showDeletionModal: false
            },
            () => {
                this.onSubmit(null, "DELETE", reason, remarks);
            }
        );
    };

    confirmReject = () => {
        this.setState({
            showRejectionModal: true
        });
    };

    confirmDelete = () => {
        this.setState({
            showDeletionModal: true
        });
    };

    isMandatory = () => {
        if (this.state.showMandatoryOption) {
            return true;
        }
        if (this.state.showMandatoryApplication) {
            return true;
        }
        return false;
    };

    get _parserCardHeader() {
        if (!this._isParserApplicable) {
            return null;
        }
        return (
            <div className={"signzy-func"}>
                <strong>TRY SIGNZY</strong>
                <img onClick={this.parseData} className={"signzy-btn"} src={SignzyIcon} alt="signzy-request" />
            </div>
        );
    }

    get showResult() {
        return (
            <div className={"signzy-form"}>
                <Result status={"404"} subTitle={"Signzy Not Applicable"} />
            </div>
        );
    }

    renderParserSection() {
        return (
            <Col span={9} className={"p-5 mb-5"}>
                <Card
                    title={this._parserCardHeader}
                    style={{
                        height: "90vh",
                        overflowY: "scroll"
                    }}>
                    {this._isParserApplicable ? this._parserForm : this.showResult}
                </Card>
            </Col>
        );
    }

    renderRejectionModal() {
        return (
            <Modals.RejectionReasonModal
                title={"Document Rejection"}
                visible={this.state.showRejectionModal}
                onCancel={this.closeModal}
                onConfirm={this.submitModal}
                reasonCategories={DOCUMENT_REJECTION_REASONS}
                addRemarks={true}
            />
        );
    }

    renderDeleteModal() {
        return (
            <Modals.RejectionReasonModal
                title={"Document Delete"}
                visible={this.state.showDeletionModal}
                onCancel={this.closeDeleteModal}
                onConfirm={this.submitDeleteModal}
                reasonCategories={DOCUMENT_REJECTION_REASONS}
                addRemarks={true}
            />
        );
    }

    actionConfigs = List([
        // {
        //     className: "approve-btn",
        //     key: "approve",
        //     label: "Approve",
        //     htmlType: "submit"
        // },
        {
            className: "reject-btn",
            key: "reject",
            label: "Reject",
            onClick: this.confirmReject
        },
        // {
        //     className: "delete-btn",
        //     key: "delete",
        //     label: "Delete",
        //     onClick: this.confirmDelete
        // }
    ]);
    isActionBtnDisabled(actionKey) {
        switch (actionKey) {
            case "approve": {
                if (!(this.props.file && !this.props.recreditViewOnlyPermission)) {
                    return true;
                }
                return false;
            }
            case "reject":
                return (
                    (!this.props.file ||
                    (this.props.file && this.props.file.document_status === DOCUMENT_CURRENT_STATUS.get("Rejected"))) && this.props.recreditViewOnlyPermission
                );
            case "delete":
                return !this.props.file && this.props.recreditViewOnlyPermission;
            default:
                return false;
        }
    }

    menu = () => {
        return (
            <Menu>
                {this.actionConfigs
                    .map((_) => (
                        <Menu.Item
                            key={_.key}
                            size={"small"}
                            className={_.className}
                            onClick={_.onClick}
                            htmlType={_.htmlType || "button"}
                            disabled={this.isActionBtnDisabled(_.key)}>
                            {_.label}
                        </Menu.Item>
                    ))
                    .toArray()}
            </Menu>
        );
    };
    remaskAadhar = () =>{
        const loadingMessage = message.loading("Aadhar Masking in progress...", 0);
        const body={
            "case_id": this.props.caseId,
            "associate_id": this.props.file?.associate || Number(this.props.file?.parse_data?.associate),
            "company_document_id": this.props.file?.id
        }
        if((this.props.file?.associate || this.props.file?.parse_data?.associate) && this.props.file?.id){
            CompanyService.companyApplicantAadharMask(body).then(res=>{
                loadingMessage();
                message.success(res?.data?.message || "Aadhar Masked Succesfully")
                if(res?.status === 200){
                    this.props.fetchFiles(this.props.caseId, this.props.companyId);
                }
            }).catch(err=>{
                console.log("Failed request", err);
                message.error("Request failed");
                loadingMessage();
            })
        }else{
            message.error("Something went wrong");
            loadingMessage();
        }
        
    }

    renderFormActions() {
        return (
            <div>
                {this.props.file?.document?.id === 63 && <Button  
                className="mr-5"
                type={"primary"}
                size={"small"}
                onClick={e=>this.remaskAadhar(e)}
                key={"remask"}
                >
                    Re-Mask
                </Button>}
                <Dropdown.Button
                    type={"primary"}
                    size={"small"}
                    key={"approve"}
                    disabled={this.isActionBtnDisabled("approve")}
                    onClick={(e) => this.onSubmit(e, "APPROVE")}
                    overlay={this.menu}>
                    Approve
                </Dropdown.Button>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.renderRejectionModal()}
                {this.renderDeleteModal()}
                <Form style={FORM_STYLE}>
                    <Row>
                        <Col className={"p-5 flex-1"} span={15}>
                            <Card
                                className={"file-viewer"}
                                title={this.getViewerTitle()}
                                extra={this.renderFormActions()}>
                                <div
                                    key={"file_viewer"}
                                    style={{
                                        height: "80vh"
                                    }}>
                                    <FileViewer
                                        file={this.props.file}
                                        filePath={this.props.completeFileUrl ? this.props.filePath : `${process.env.FILE_DOWNLOAD_URL}/${this.props.filePath}`}
                                        fileType={this.props.fileType}
                                        createNewDocument={this.props.createNewDocument}
                                    />
                                </div>
                            </Card>
                        </Col>
                        {this.renderParserSection()}
                    </Row>
                </Form>
            </React.Fragment>
        );
    }
}

const FORM_STYLE = {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
};

SignzyDataForm.propTypes = {
    form: PropTypes.object,
    documentType: PropTypes.string,
    fileType: PropTypes.string,
    filePath: PropTypes.string,
    file: PropTypes.object,
    docMasterList: PropTypes.array,
    associates: PropTypes.array,
    updateDocument: PropTypes.func,
    addressesList: PropTypes.object,
    parseData: PropTypes.func,
    panParsedData: PropTypes.object,
    aadhaarParsedData: PropTypes.object,
    createNewDocument: PropTypes.func,
    bankAccounts: PropTypes.array,
    companyId: PropTypes.number
};

export default Form.create({
    mapPropsToFields: ({ file, associates, addressesList, bankAccounts }) => {
        if (file && file.parse_data && file.parse_data.length !== 0) {
            let documentId = file && file?.document &&  file?.document_option  ? `${file?.document?.id}-${file?.document_option}` : file?.document?.id;
            let associate = {};
            let address = {};
            let bank = {};
            let associateId = null;
            if (file.parse_data.associate) {
                associateId = String(file.parse_data.associate);
                associate = associates.get(Number(file.parse_data.associate), { parserFieldValues: {} })
                    .parserFieldValues;
            }else if(file.associate){
                associateId = String(file.associate);
                associate = associates.get(Number(file.associate), { parserFieldValues: {} })
                    .parserFieldValues;
            }
            
            if (file.parse_data.address) {
                address = addressesList.find((_) => _.associate === Number(associateId));
            } else {
                address = {};
            }

            bank = bankAccounts && bankAccounts.find((_) => _.associate === "company");
            const documentType = file.document && String(documentId);
            const parserType = DOCUMENT_CODES.get(documentType);
            const fields = List(DOCUMENT_TYPE_FIELD_CONFIGS.get(parserType, []))
                .toMap()
                .mapEntries(([, v]) => {
                    if (v === "first_name") {
                        if (associate && associate[v]) {
                            return [v, associate[v]];
                        } else if (file.parse_data && file.parse_data["first_name"]) {
                            const nameArr = file.parse_data[v].split(" ");
                            if (nameArr.length === 1) {
                                return [v, nameArr[0]];
                            }
                            return [v, nameArr.slice(0, nameArr.length - 1).join(" ")];
                        }
                    }
                    if (v === "last_name") {
                         if (associate && associate[v]) {
                            return [v, associate[v]];
                        } else if (file.parse_data && file.parse_data["first_name"]) {
                            const nameArr = file.parse_data["first_name"].split(" ");
                            if (nameArr.length > 1) {
                                return [v, nameArr[nameArr.length - 1]];
                            } else {
                                return [v, null];
                            }
                        }
                    }
                    if (v === "name_pan") {
                        if (associate && associate[v]) {
                            return [v, associate[v]];
                        } else if (file.parse_data && file.parse_data["first_name"]) {
                            const nameArr = file.parse_data["first_name"];
                            return [v, nameArr];
                        }
                    }
                    if (v === "name_aadhar") {
                        if (associate && associate[v]) {
                            return [v, associate["name_aadhar"]];
                        } else if (file.parse_data && file.parse_data["first_name"]) {
                            const nameArr = file.parse_data["first_name"];
                            return [v, nameArr];
                        }
                    }
                    if (v.includes("address")) {
                        let key = v.split(".")[1];
                        if (key && address) {
                            return [v, address[key]];
                        }
                    }
                    if (v.includes("address.address_line_1")) {
                        return [v, file.parse_data?.address["address_line_1"]];
                    }
                    if (v.includes("address.pincode")) {
                            return [v, file.parse_data?.address["pincode"]];
                    }
                    if (v.includes("bank")) {
                        let key = v.split(".")[1];
                        if (key === "ifsc_code" && bank) {
                            return [v, bank["bank_branch"]];
                        }
                        if (key && bank) {
                            return [v, bank[key]];
                        }
                        return [v, null];
                    }
                    if (v === "dob") {
                        if (associate[v] && associate[v]._isAMomentObject && !isNaN(associate[v].date())) {
                            return [v, associate[v]];
                        }
                        return [v, file.parse_data[v] || null];
                    }
                    if (v === "dob_pan") {
                        if (associate[v] && associate[v]._isAMomentObject && !isNaN(associate[v].date())) {
                            return [v, associate[v]];
                        }
                        return [v, file.parse_data["dob"] || null];
                    }
                    if (v === "is_vernacular_required") {
                        if (associate[v] != null) {
                            return [v, associate[v].toString()];
                        }
                        return [v, 'true'];
                    }
                    if (v === "dob_aadhar") {
                        if (associate[v] && associate[v]._isAMomentObject && !isNaN(associate[v].date())) {
                            return [v, associate[v]];
                        }
                        return [v, file.parse_data["dob"] || null];
                    }
                    return [v, associate[v] || file.parse_data[v] || null];
                })
                .toJS();
            return Map({
                document_type: documentType,
                associate: associateId,
                ...fields
            })
                .map((value, key) => {
                    if (key.includes("dob_pan")) {
                        let formats = ["DD/MM/YYYY", "DD-MM-YYYY"];
                        let format = value && (value._isAMomentObject ? value : value.includes("/") ? formats[0] : formats[1]);
                        return Form.createFormField({
                            value:
                                value &&
                                (value._isAMomentObject ? value : moment(value, format).isValid() ? moment(value, format) : null)
                        });
                    }
                    if (key === "dob") {
                        let formats = ["DD/MM/YYYY", "DD-MM-YYYY"];
                        let format = value && (value._isAMomentObject ? value : value.includes("/") ? formats[0] : formats[1]);
                        return Form.createFormField({
                            value:
                                value &&
                                (value._isAMomentObject ? value : moment(value, format).isValid() ? moment(value, format) : null)
                        });
                    }
                    if (key === "dob_aadhar") {
                        let formats = ["DD/MM/YYYY", "DD-MM-YYYY"];
                        let format = value && (value._isAMomentObject ? value : value.includes("/") ? formats[0] : formats[1]);
                        return Form.createFormField({
                            value:
                                value &&
                                (value._isAMomentObject ? value : moment(value, format).isValid() ? moment(value, format) : null)
                        });
                    }
                    if (key === "gender") {
                        let gender = null;
                        if (value === "male") {
                            gender = GENDER_TYPES.get("Male");
                        }
                        if (value === "female") {
                            gender = GENDER_TYPES.get("Female");
                        }
                        if (value && typeof value === "number") {
                            return Form.createFormField({
                                value: String(value)
                            });
                        }
                        return Form.createFormField({
                            value: gender && String(gender)
                        });
                    }
                    if (key.includes("address")) {
                        return Form.createFormField({
                            value: value ? value : null
                        });
                    }
                    if (key.includes("bank")) {
                        return Form.createFormField({
                            value: value ? value : null
                        });
                    }
                    return Form.createFormField({
                        value: value ? (value._isAMomentObject ? value : String(value)) : null
                    });
                })
                .toJS();
        } else if (file && file.document && file.document.id) {
            let documentId = file && file.document &&  file.document_option  ? `${file.document.id}-${file.document_option}` : file.document.id;
            return Map({
                document_type: String(documentId)
            }).map(value => {
                return Form.createFormField({
                    value
                });
            }).toJS();
        }
    },
    onFieldsChange: (props, fields) => {
        if((fields.document_type && !fields.document_type.validating) && fields['document_type'] && fields['document_type'].value && props.file  && fields.document_type['touched']){
            let oldDocumentName = props.docMasterList && props.docMasterList.filter(_ => _.id == props.file.document.id)
            let newDocumentName = props.docMasterList && props.docMasterList.filter(_ => _.id == (fields['document_type'].value.includes('-') ? Number(fields['document_type'].value.split('-')[0])  : Number(fields['document_type'].value)) )[0].document_name || '';
            let docOption = fields['document_type'].value && fields['document_type'].value.includes('-')? fields['document_type'].value.split('-')[1] : '';
            confirm({
                icon : null,
                title: 'Are you sure ?',
                content: <p>Are you sure you want to change this document from <b>{oldDocumentName[0].document_name} {props.file.document_option && props.file.document_option == 12 ? '- Front' :props.file.document_option == 13 ? '- Back' : '' }</b> to <b>{newDocumentName} {fields['document_type'].value.includes('-') && docOption == 12 ? '- Front' :docOption == 13 ?  '- Back' : '' }</b> <br/><br/> <p style={{color : "red"}}> This may impact the case approval !</p></p>,
                onOk() {
                },
                onCancel() {
                },
              });
        }
        try {
            const errors = Map(fields).toList().reduce((agg, _) => !!_.errors || agg, false);
            if (
                !errors &&
                ((fields.document_type && !fields.document_type.validating) ||
                    (fields.associate && !fields.associate.validating))
            ) {
                const { file, associates, addressesList } = props;
                const parseData = file && file.parse_data && file.parse_data.length !== 0 ? file.parse_data : {};
                let { associate, document_type } = props.form.getFieldsValue(["document_type", "associate"]);
                let address = addressesList.find((_) => _.associate === Number(associate));
                let bankAccount = null;
                if (associate) {
                    associate = associates.get(Number(associate), { parserFieldValues: {} }).parserFieldValues;
                } else {
                    associate = {};
                }
                if (document_type === 34 || document_type === "34") {
                    bankAccount = props.bankAccounts && props.bankAccounts.find(_ => (!_.associate || _.associate === "company"));
                }
                const parserType = DOCUMENT_CODES.get(document_type);
                const fields = List(DOCUMENT_TYPE_FIELD_CONFIGS.get(parserType, []))
                    .toMap()
                    .mapEntries(([, v]) => {
                        if (v === "first_name") {
                            if (associate && associate[v]) {
                                return [v, associate[v]];
                            } else if (parseData && parseData["first_name"]) {
                                const nameArr = parseData[v].split(" ");
                                return [v, nameArr.slice(0, nameArr.length - 1).join(" ")];
                            }
                        }
                        if (v === "last_name") {
                            if (associate && associate[v]) {
                                return [v, associate[v]];
                            } else if (parseData && parseData["first_name"]) {
                                const nameArr = parseData["first_name"].split(" ");
                                return [v, nameArr[nameArr.length - 1]];
                            }
                        }
                        if (v.includes("address")) {
                            let key = v.split(".")[1];
                            if (key && address) {
                                return [v, address[key]];
                            }
                            return [v, null];
                        }
                        if (v.includes("bank")) {
                            let key = v.split(".")[1];
                            if (key === "ifsc_code") {
                                return [v, bankAccount && bankAccount["bank_branch"]];
                            }
                            if (key && bankAccount) {
                                return [v, (bankAccount && bankAccount[key]) || parseData[v]];
                            }
                            return [v, null];
                        }
                        if (v === "dob") {
                            if (associate[v] && associate[v]._isAMomentObject && associate[v].isValid()) {
                                return [v, associate[v]];
                            }
                            return [v, parseData[v] || null];
                        }
                        if (v === "dob_pan") {
                            if (associate[v] && associate[v]._isAMomentObject && associate[v].isValid()) {
                                return [v, associate[v]];
                            }
                            return [v, parseData[v] || null];
                        }
                        return [v, associate[v] || parseData[v] || null];
                    })
                    .toJS();
                return setTimeout(
                    () =>
                        props.form.setFields(
                            Map({
                                ...fields
                            })
                                .map((value, fieldName) => {
                                    if (fieldName === "dob") {
                                        return Form.createFormField({
                                            value:
                                                value &&
                                                (value._isAMomentObject
                                                    ? value
                                                    : moment(value).isValid() ? moment(value) : null),
                                            errors: fields[fieldName] ? fields[fieldName].errors : null
                                        });
                                    }
                                    if (fieldName === "gender") {
                                        let gender = null;
                                        if (value === "male") {
                                            gender = GENDER_TYPES.get("Male");
                                        }
                                        if (value === "female") {
                                            gender = GENDER_TYPES.get("Female");
                                        }
                                        if (value && typeof value === "number") {
                                            return Form.createFormField({
                                                value: String(value)
                                            });
                                        }
                                        return Form.createFormField({
                                            value: gender && String(gender)
                                        });
                                    }
                                    if (fieldName.includes("address")) {
                                        return Form.createFormField({
                                            value: value ? value : null
                                        });
                                    }
                                    if (fieldName.includes("bank")) {
                                        return Form.createFormField({
                                            value: value ? value : null
                                        });
                                    }
                                    return {
                                        value: value ? (value._isAMomentObject ? value : String(value)) : null,
                                        errors: fields[fieldName] ? fields[fieldName].errors : null
                                    };
                                })
                                .toJS()
                        ),
                    300
                );
            }
        } catch (error) {
            console.error("--> ", error);
        }
    }
})(SignzyDataForm);

/* eslint-enable */
